module.exports = __webpack_public_path__ + "img/1.30ad3545.jpg";